<template>
    <!-- {{ model }} -->
     <form @submit.prevent="onSubmit">
        <div v-if="viewData.Errors && viewData.Errors.length > 0">
            <h3>Es sind Fehler aufgetreten</h3>	
            <p>Folgende Fehler sind aufgetreten:</p>
            <p v-for="msg in viewData.Errors">{{msg}}</p>
            <p>Bitte korrigieren Sie Ihre Eingaben und schicken Sie das Formular noch einmal ab.</p>
        </div>

       <div class="input-group">
            <div class="form input-checkbox">
                <p>
                    <input class="check-box" id="Direkt" name="Direkt" type="checkbox" v-model="model.direkt">
                    Ja, ich möchte mich als <strong>Apotheke</strong> für die Direktbestellung über MSV3 registrieren.
                </p>
            </div> 
            <div class="form input-checkbox">
                <p>
                    <input class="check-box" id="Shop" name="Shop" type="checkbox" v-model="model.shop">
                    Ja, ich möchte mich als <strong>Apotheke</strong> auch unverbindlich für den Onlineshop ALIUD FACHWELT registrieren.
                </p>
            </div>
        </div>
        <div class="input-group" v-if="model.shop">
            <h3>
                Zugangsdaten
            </h3>
            <div class="form input-text-single">
                <span class="input">
                    <input id="Benutzername" name="Benutzername" placeholder="Gewünschter Benutzername*" type="text" v-model="model.benutzername" required>
                </span>
            </div>
            <div class="form input-text-double-1">
                <span class="input">
                    <input id="Passwort" name="Passwort" placeholder="Passwort" type="password" v-model="model.passwort">
                </span>
                <span class="password-strength-container">
                    <span class="password-strength"></span>
                </span>
            </div>
            <div class="form input-text-single-half">
                <span class="input">
                    <input id="PasswortWiederholung" name="PasswortWiederholung" placeholder="Passwort bestätigen" type="password" v-model="model.passwortWiederholung">
                </span>
            </div>
        </div>
        <div class="input-group">
            <h3>
                Persönliche Angaben
            </h3>
            <!-- Input zweispaltig 1 -->
            <div class="form input-text-double-1">
                <span class="input">
                    <span class="select-style">
                    <select name="Anrede" id="Anrede" v-model="model.anrede" required>
                        <option value="" disabled>Anrede*</option>
                        <option v-for="s in anreden" :value="s" >{{s}}</option>
                    </select>
                    </span>
                </span>
                <span class="input">
                    <span class="select-style">
                    <select id="Titel" name="Titel" v-model="model.titel">                    
                        <option :value="null" disabled>Titel</option>
                        <option v-for="s in titel" :value="s">{{s}}</option>
                    </select>
                    </span>
                </span>		
            </div>
            <div class="form input-text-double-1">
                <span class="input">
                    <!-- <label for="Vorname">Vorname*</label> -->
                    <input id="Vorname" name="Vorname" placeholder="Vorname*" type="text" v-model="model.vorname" required />
                </span>
                <span class="input">
                    <!-- <label for="Nachname">Nachname*</label> -->
                    <input id="Nachname" name="Nachname" placeholder="Nachname*" type="text" v-model="model.nachname" required/>
                </span>
            </div>
        </div>
        <div class="input-group">
            <h3>
                Berufliche Angaben
            </h3>
            <div class="form select">
                <span class="input">
                    <span class="select-style">
                        <select name="Berufsbezeichnung" id="Berufsbezeichnung" v-model="model.berufsbezeichnung" required>                    
                            <option value="" disabled>Ihre Berufsbezeichnung*</option>
                            <option v-for="b in rollen" :value="b" >{{b}}</option>
                        </select>
                    </span>
                </span>
            </div>
            <div class="form input-text-single-half">
                <span class="input">
                    <input id="Berufsnummer" name="Berufsnummer" placeholder="BGA / BTM-Nr.*" type="text" v-model="model.berufsnummer" required>
                </span>
            </div>
            <div class="form input-text-single">
                <span class="input">
                    <input id="Institution" name="Institution" placeholder="Institutionsname/Apothekenname*" type="text" v-model="model.institution" required>
                </span>
            </div>
            <div class="form input-text-single kundennr">
                <span class="input">
                    <!-- <label for="KundenNummer">Ihre ALIUD-Kundennummer</label> -->
                    <input id="KundenNummer" name="KundenNummer" placeholder="Ihre ALIUD-Kundennummer" type="text" v-model="model.kundennummer">
                </span>
            </div>
            <!-- Input zweispaltig 1 -->
            <div class="form select">
                <span class="input">
                    <span class="select-style">
                        <select name="BerufsnachweisArt" id="BerufsnachweisArt" v-model="model.berufsnachweisArt">
                            <option class="zustellung" :value="null" disabled>Zustellung Ihres Berufsnachweises per</option>
                            <option v-for="s in berufsnachweise"  :value="s">{{s}}</option>}
                        </select>
                    </span>
                </span>
            </div>
            <upload-berufsnachweis v-if="model.berufsnachweisArt == 'Upload'" :model="model" :sessionId:="sessionId"></upload-berufsnachweis>
        </div>
        <div class="input-group">
            <h3>
                Berufliche Kontaktdaten
            </h3>
            <div class="form input-text-single">
                <span class="input">
                    <!-- <label for="Strasse">Straße*</label> -->
                    <input id="Strasse" name="Strasse" placeholder="Straße und Hausnummer*" type="text" v-model="model.strasse" required>
                </span>
            </div>
            <div class="form input-text-triple-1">
                <span class="input">
                    <!-- <label for="Land">Land</label> -->
                    <input id="Land" name="Land" placeholder="Land" :readonly="true" type="text" v-model="model.land">
                </span>
                <span class="input">
                    <!-- <label for="Plz">PLZ*</label> -->
                    <input id="Plz" name="Plz" placeholder="PLZ*" type="text" v-model="model.plz" required>
                </span>
                <span class="input">
                    <!-- <label for="Ort">Ort*</label> -->
                    <input id="Ort" name="Ort" placeholder="Ort*" type="text" v-model="model.ort" required>                    
                </span>
            </div>
            <div class="form input-text-single">
                <span class="input">
                    <input id="EMail" name="EMail" placeholder="E-Mail-Adresse*" type="email" v-model="model.eMail" required>                    
                </span>
            </div>
            <div class="form input-text-single">
                <span class="input">
                    <input id="EMailWiederholen" name="EMailWiederholen" placeholder="E-Mail-Adresse wiederholen*" type="email" v-model="model.eMailWiederholen" required>                        
                </span>
            </div>
            <div class="form input-text-double-1">
                <span class="input">
                    <input id="Telefon" name="Telefon" placeholder="Telefon" type="text" v-model="model.telefon">
                </span>
                <span class="input">
                    <input id="Fax" name="Fax" placeholder="Fax" type="text" v-model="model.fax">
                </span>
            </div>
        </div>
        <div class="input-group">
            <h3>
                Newsletter
            </h3>
            <newsletter-abos :model="model"></newsletter-abos>
            <div class="textonly">
                <hr>
            </div>
            <div class="textonly">
                <h3>AGB und Datenschutzbestimmung:</h3>
            </div>
            <div class="input-group">
                <div class="form input-checkbox">
                    <p>
                        <input class="check-box" id="NewsletterAkzeptieren" name="NewsletterAkzeptieren" type="checkbox" v-model="model.agbGelesen" required>
                        Ja, ich habe die <a href="https://www.aliud.de/metaseiten/datenschutz" target="_blank"> Informationen zum Datenschutz, </a>
                        <a href="#" class="popover privacy"> Hinweise zur Datenverwendung</a> und die<br>
                        <a href="https://www.aliud.de/metaseiten/agb" target="_blank"> Allgemeinen Geschäftsbedingungen</a> gelesen und bin damit einverstanden.*                        
                    </p>
                    <p>Die datenschutzrechtlichen Informationspflichten nach Art. 13 DSGVO können Sie <a href="https://www.stada.de/konzern/ueber-stada/compliance.html" target="_blank">hier</a> abrufen.</p>
                </div>
            </div>
            <div class="textonly">
                <hr>
            </div>
            <h3>
                Mitteilung
            </h3>
            <div class="form textarea">
                <span>
                    <textarea cols="20" id="Mitteilung" placeholder="Sie wollen uns etwas mitteilen?" v-model="model.mitteilung"></textarea>
                </span>
            </div>
            <div class="textonly legend">
                <p>*Pflichtfelder</p>
            </div>
	  </div>
      <div class="form input-submit">
        <!-- <input type="submit" name="input-submit" id="input-submit" @click="onSubmit" value="Registrieren"> -->
            <input type="submit" name="input-submit" id="input-submit" value="Registrieren" >
        </div>
        <div class="popoverContent privacy">
            <h3>Hinweise zur Datenverwendung: </h3>
            <p>
                Ich willige gegenüber der ALIUD PHARMA in die Verwendung meiner oben aufgeführten E-Mail-Adresse zur Zusendung von Newslettern ein. Eine Abmeldung ist jederzeit möglich. Datennutzung und -speicherung: Wir machen Sie darauf aufmerksam, dass ALIUD PHARMA Ihre Daten ausschließlich im Rahmen der gesetzlichen Bestimmungen zur Übersendung von Newslettern verwenden wird und diese hierzu auch an externe Dienstleister weitergeben kann. Für den Fall, dass Sie weitere Informationen zum Umgang mit Ihren Daten erfahren und/oder zukünftig keine Informationen zu unseren Produkten oder Veranstaltungen mehr erhalten möchten, können Sie uns dies ohne Angabe von Gründen über unten genannte Kontaktdaten mitteilen.
            </p>
        </div>
    </form>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import NewsletterAbos from '../NewsletterAbos.vue';
import UploadBerufsnachweis from '../UploadBerufsnachweis.vue';
import { extractAttrs } from '@/services/extract-attrs';
import axios from 'axios';
import ApiService from '@/services/apiService';

const RegistrierungDafuerForm = defineComponent({
    name:"Registrierung Dafuer Form",
    data(){
        return {
            model: {} as {benutzername:string, sessionId:string}, 
            viewData: {}, 
            anreden: ["Frau","Herr"],
            titel: ["Dr.", "Prof.", "Prof. Dr."],
            rollen: [] as string[],
            berufsnachweise: ["Upload","Fax","Post"],
            sessionId:"",
        }
    },
    
    props:{
        container: HTMLElement
    },
    async beforeMount() {
        var attrs = extractAttrs(this.container!);
        this.sessionId = attrs["session"];

        var response = await axios.get( "/umbraco/login/RegistrierungDafueForm/GetModelDafuer");
        this.model = response.data;
        const roleObj = this.model.rollen as any;
        for(const key of Object.keys(roleObj)) {
            this.rollen.push(roleObj[key].name);
        }
        this.model.anrede = this.model.anrede??"";
        this.model.berufsbezeichnung = this.model.berufsbezeichnung??"";
    },
    methods:{
        async onSubmit(){
             var params : any = this.model;
            params["SessionId"] = this.sessionId;
            this.viewData = await ApiService.Instance.PostData( "/umbraco/login/RegistrierungDafueForm/SendMailDafue", params );
            if(this.viewData.redirectTo){
                window.location.href = this.viewData.redirectTo;
            }
        }
    },
    components:{
        UploadBerufsnachweis,
        NewsletterAbos
    }
})
export default RegistrierungDafuerForm;
</script>